/** Max length for document/file display names (title or filename) in lists. */
const DISPLAY_NAME_MAX_LENGTH = 75;

/**
 * Truncates a display name to DISPLAY_NAME_MAX_LENGTH with an ellipsis.
 * Use for document titles/filenames in Global Documents, Knowledge Base, Data Sources.
 * Full text should be shown in the element's `title` for tooltip.
 */
export function truncateDisplayName(text: string | null | undefined): string {
  const s = text ?? '';
  if (s.length <= DISPLAY_NAME_MAX_LENGTH) return s;
  return s.slice(0, DISPLAY_NAME_MAX_LENGTH) + '…';
}
